import React from 'react';
import { element, number, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { Button, Card, CardTitle } from '@thd-olt-component-react/core-ui';
import { ArticleGuides as ArticleGuidesComponent } from '@thd-olt-component-react/thd-recs-containers';

import classnames from 'classnames/bind';
import { getSvocId } from '../../utils';

import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedArticleGuides({
  SCROLL_BUFFER,
  PLACEHOLDER,
  REQUEST_KEY,

  guestUserId,
  slidesPer,
  customRenderId,
}) {
  const customerID = getSvocId() || guestUserId;

  return (
    <QueryProvider cacheKey="article-guides">
      <Hydrator
        id={customRenderId}
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        placeholder={PLACEHOLDER}
      >
        <Card>
          {/**
           * @TODO
           * Refactor `app.scss` to use CSS Modules.
           */}
          <CardTitle
            className="card__title u-width-100"
            title="DIY Guides For Your Projects"
            action={{
              href: '/c/diy_projects_and_ideas',
              content: (
                <Button link transparent>
                  View All
                </Button>
              ),
            }}
          />
          <ArticleGuidesComponent
            hideTitle
            requestKey={REQUEST_KEY}
            showLoading
            customerID={customerID}
            slidesPer={slidesPer}
          />
        </Card>
      </Hydrator>
    </QueryProvider>
  );
}

CustomRenderedArticleGuides.propTypes = {
  SCROLL_BUFFER: number,
  PLACEHOLDER: element,
  REQUEST_KEY: string,

  guestUserId: string,
  slidesPer: number,
  customRenderId: string,
};

CustomRenderedArticleGuides.defaultProps = {
  SCROLL_BUFFER: undefined,
  PLACEHOLDER: undefined,
  REQUEST_KEY: undefined,

  guestUserId: undefined,
  slidesPer: undefined,
  customRenderId: undefined,
};
